import React from 'react';
import { Box } from '../primitives';
import styled from 'styled-components';
import css from '@styled-system/css';

type Props = {
  choiceName: string;
  choiceList: { value: string; label: string; checked: boolean }[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const RadioInput = ({ choiceName, choiceList, onChange }: Props) => (
  <Box>
    {choiceList.map(choice => (
      <SLabel htmlFor={choice.value} key={choice.value}>
        <SInput
          type="radio"
          name={choiceName}
          value={choice.value}
          id={choice.value}
          onChange={onChange}
          checked={choice.checked}
        />
        <SFill />
        {choice.label}
      </SLabel>
    ))}
  </Box>
);

const SFill = styled.span`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  ${css({
    mr: 'small',
    border: '2px solid',
    borderColor: 'secondary',
  }) as any}
  &::after {
    ${css({ backgroundColor: 'accent' }) as any}
    content: '';
    width: 0;
    height: 0;
    border-radius: 50%;
    opacity: 0;
    transition: all 110ms;
  }
`;

const SInput = styled.input`
  position: absolute;
  visibility: hidden;
  display: none;
  &:checked + ${SFill} {
    ${css({ borderColor: 'accent' }) as any}
    &::after {
      width: 10px;
      height: 10px;
      opacity: 1;
    }
  }
`;

const SLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  ${css({ color: 'primary' }) as any}
`;
